module.exports = __webpack_public_path__ + "static/media/11-d-calendar.3abc85cc.png";